import { Role } from '@caresend/types';
import update from 'immutability-helper';
import 'lodash-unified';
import '../typeValidation/booking.js';
import '../typeValidation/draftWaypoint.js';
import '../typeValidation/feedback.js';
import '../environment/crypto/index.js';
import 'dayjs';
import '../formatters/string.js';
import 'ngeohash';
import '../formatters/location.js';
import '../initializers/user.js';
import '../typeValidation/note.js';
import '../typeValidation/procedure.js';
import '../typeValidation/samples.js';
import '../typeValidation/shift.js';
import '../typeValidation/shipmentInfo.js';
import '../typeValidation/supply.js';
import '../typeValidation/timeSlot.js';
import '../typeValidation/waypoint.js';
import '../typeValidation/waypointAction.js';
import '../dataHelpers/product.js';
import 'libphonenumber-js';
import '../dataHelpers/supplyBoxPackerHelper.js';
import { getUserPath } from '../dataHelpers/user.js';
import { encryptionConfig } from './init.js';
import { encryptUserID } from './user.js';

async function encryptOrder(order, creator) {
  var _a, _b, _c;

  if (!encryptionConfig) throw Error('Encryption not initialized when encrypting order');
  if (!encryptionConfig.getValueOnce) throw Error('getValueOnce not initialized when encrypting order');
  const orderTransactions = order.transactions;
  const orderWithoutTransactions = update(order, {
    $unset: ['transactions']
  });
  const encryptedOrder = orderWithoutTransactions;
  if (orderTransactions) encryptedOrder.transactions = await encryptionConfig.encryptData(orderTransactions);
  let createdByRole = (_a = creator === null || creator === void 0 ? void 0 : creator.role) !== null && _a !== void 0 ? _a : null;
  let createdByID = (_b = creator === null || creator === void 0 ? void 0 : creator.id) !== null && _b !== void 0 ? _b : null;

  if (!createdByRole) {
    createdByID = (_c = order.createdBy) !== null && _c !== void 0 ? _c : null;
    if (!createdByID) throw Error('Order createdBy ID is required');
    createdByRole = await encryptionConfig.getValueOnce(getUserPath(createdByID, 'role'));

    if (createdByRole === Role.PATIENT) {
      encryptedOrder.createdBy = await encryptUserID(createdByID);
    }
  }

  return encryptedOrder;
}

export { encryptOrder };
